import { Box, Button, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import LocationsDialog from '../activity/createActivity/moreOptions/location/LocationsDialog';
import RoleSwitchSetting from './RoleSwitchSetting';
import TimerToggle from './TimerToggle';
import NotificationToggle from './NotificationToggle';
import PersonaSelector from './PersonaSelector';

const ProfileSettings = () => {
  const { t } = useTranslation();
  const [locationsDialog, setLocationsDialogOpen] = useState(false);

  return (
    <>
      <Stack spacing={1} sx={{ p: 1 }}>
        <RoleSwitchSetting id="roleSwitch" title="Your role right now" />
        <PersonaSelector id="personaSelector" title="persona.settings.title" />
        <NotificationToggle id="notificationToggle" title="Notifications" />
        <TimerToggle />
        <Box
          sx={{
            p: 2,
            display: 'flex',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <Stack
            justifyContent={'space-between'}
            direction={'row'}
            width={'100%'}
            alignItems={'center'}
          >
            <Typography variant="h6" color={'primary'}>
              {t('Locations')}
            </Typography>
            <Button
              variant={'outlined'}
              color={'primary'}
              onClick={() => setLocationsDialogOpen(true)}
            >
              {t('My locations')}
            </Button>
          </Stack>
        </Box>
      </Stack>
      <LocationsDialog open={locationsDialog} onClose={() => setLocationsDialogOpen(false)} />
    </>
  );
};

export default ProfileSettings;
